// extracted by mini-css-extract-plugin
export var link = "_rs-0";